import React from 'react';
import SupportServicesTable from './SupportServicesTable';

const SupportServicesDate = ({data}) => {
  return (
        <SupportServicesTable data={data} />
  );
};

export default SupportServicesDate;
